import React from "react";
import { useModalStore } from "../zustand/modal";
//components
import Portal from "../Portal";
import DefaultButton from "./DefaultButton";
import { useProjectStore } from "../zustand/priceTagSystem/project";
import { useEstimateStore } from "../zustand/priceTagSystem/estimate";
import TextInput from "./TextInput";
import { notify } from "./alertToastify";
import { sortXorY } from "../util/sort";

// 전역 모달
export default function DirectProcessModal() {
    const { direct_data: data, closeDirectModal: closeModal } = useModalStore();
    const { project_info, setProjectInfo } = useProjectStore();
    const { estimate_info, setEstimateInfo } = useEstimateStore();
    const temp = data?.temp;

    if (!temp) return null;

    const direct_list = project_info.addon.filter((d) => d.id === temp.id);

    const option_list = sortXorY(data.temp.option, "sort", "option_id");

    const table_header_list = [...option_list.map((d) => d.option_name), ""];

    function addDirect() {
        if (project_info.is_final)
            return notify("진견적 책정 후에는 변경할 수 없습니다.", "warn");

        //기본값 (옵션 중 가격만 quantity를 0, 나머지는 ""이다. final_price는 모두 0으로 지정한다.)
        const default_value = {
            ...temp,
            quantity: 1,
            final_price: 0,
            option: temp.option.map((o) => ({
                ...o,
                quantity: o.input_type === "number" ? 0 : "",
                final_price: 0,
            })),
        };

        const project_temp = {
            ...project_info,
            addon: [...project_info.addon, default_value],
        };

        const estimate_temp = {
            ...estimate_info,
            addon: [...estimate_info.addon, default_value],
        };

        setProjectInfo(project_temp);
        setEstimateInfo(estimate_temp);
    }

    function saveDirectData({ name, value, extraInfo }) {
        const { row_idx, option_id } = extraInfo;

        let project_cur_idx = -1;
        let cur_data = null; //estimate에 넘길 데이터

        //값 저장
        const project_temp = {
            ...project_info,
            addon: project_info.addon.map((d) => {
                if (d.id === temp.id) {
                    project_cur_idx++; //idx를 증가시키면서, 직접공정추가 데이터를 찾는다.
                    if (project_cur_idx === row_idx) {
                        //row_idx과 현재 idx가 같으면 현재 수정중인 row이다.
                        let temp = {
                            ...d,
                            option: d.option.map((o) =>
                                o.option_id === option_id
                                    ? { ...o, quantity: value }
                                    : o
                            ),
                        };

                        const final_price = temp.option.find(
                            (o) => o.option_name === "가격"
                        ).quantity;

                        //입력한 가격 그대로 final_price에 저장
                        temp = {
                            ...temp,
                            option: temp.option.map((o) =>
                                o.option_name === "가격"
                                    ? { ...o, final_price }
                                    : { ...o, final_price: 0 }
                            ),
                        };
                        cur_data = temp; //estimate에도 똑같은 값을 넘기기 위해 저장
                        return temp;
                    }
                    return d;
                }
                return d;
            }),
        };
        setProjectInfo(project_temp);

        let estimate_cur_idx = -1;
        const estimate_temp = {
            ...estimate_info,
            addon: estimate_info.addon.map((d) => {
                if (d.id === temp.id) {
                    estimate_cur_idx++; //idx를 증가시키면서, 직접공정추가 데이터를 찾는다.
                    if (estimate_cur_idx === row_idx) {
                        return cur_data;
                    }
                }
                return d;
            }),
        };

        setEstimateInfo(estimate_temp);
    }

    function deleteDirectProcess({ row_idx, name }) {
        //직접 공정 추가 삭제
        if (project_info.is_final)
            return notify("진견적 책정 후에는 변경할 수 없습니다.", "warn");

        let project_cur_idx = -1;
        let estimate_cur_idx = -1;

        const project_temp = {
            ...project_info,
            addon: project_info.addon.filter((d) => {
                if (d.id === temp.id) {
                    project_cur_idx++;
                    if (project_cur_idx !== row_idx) {
                        return d;
                    }
                } else {
                    return d;
                }
            }),
        };
        setProjectInfo(project_temp);

        const estimate_temp = {
            ...estimate_info,
            addon: estimate_info.addon.filter((d) => {
                if (d.id === temp.id) {
                    estimate_cur_idx++;
                    if (estimate_cur_idx !== row_idx) {
                        return d;
                    }
                } else {
                    return d;
                }
            }),
        };
        setEstimateInfo(estimate_temp);
    }

    const header_col = `grid-cols-${table_header_list.length} `;

    return (
        <Portal>
            <div className="h-max w-[50%] bg-white fixed top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] z-[99]">
                <div className="py-[15px] px-[30px] flex justify-between items-center">
                    <h5 className="text-[24px] font-['spoqa_regular']">
                        직접 공정 입력
                    </h5>
                    <div>
                        <DefaultButton
                            margin="0 20px 0 0"
                            height="40px"
                            width="100px"
                            onClick={addDirect}
                        >
                            추가
                        </DefaultButton>
                        <DefaultButton
                            margin="0 20px 0 0"
                            height="40px"
                            width="100px"
                            onClick={closeModal}
                        >
                            적용
                        </DefaultButton>
                        <DefaultButton
                            height="40px"
                            width="100px"
                            backgroundColor="#c4c4c4"
                            onClick={closeModal}
                        >
                            취소
                        </DefaultButton>
                    </div>
                </div>

                <div
                    className={`grid gap-[1px] bg-black ${header_col} border-t border-black`}
                >
                    {table_header_list.map((name, idx) => (
                        <div
                            key={`table-header-${idx}`}
                            className="bg-[#c4c4c4] py-[10px] px-[20px]"
                        >
                            {name}
                        </div>
                    ))}
                    {direct_list &&
                        direct_list.length > 0 &&
                        direct_list.map((d, row_idx) => {
                            return (
                                <React.Fragment
                                    key={`table-content-row-${row_idx}`}
                                >
                                    {/* OPTION_TEMP는 테이블을 그리기 위한 용도, 진짜 깂은 directProcessList 안에 */}
                                    {option_list.map((o, i) => {
                                        return (
                                            <div
                                                className="bg-[#fff] py-[10px] px-[20px]"
                                                key={`direct-${row_idx}-${i}`}
                                            >
                                                <TextInput
                                                    value={
                                                        d.option[i]?.quantity
                                                    }
                                                    width="100%"
                                                    name={o.name}
                                                    onChange={saveDirectData}
                                                    disabled={
                                                        project_info.is_final
                                                            ? true
                                                            : false
                                                    }
                                                    extraInfo={{
                                                        ...o,
                                                        row_idx,
                                                    }}
                                                    type={o.input_type}
                                                />
                                            </div>
                                        );
                                    })}
                                    <div className="bg-[#fff] py-[10px] px-[20px] text-center">
                                        <DefaultButton
                                            height="30px"
                                            width="50px"
                                            onClick={() =>
                                                deleteDirectProcess({
                                                    row_idx,
                                                    name: d.name,
                                                })
                                            }
                                        >
                                            삭제
                                        </DefaultButton>
                                    </div>
                                </React.Fragment>
                            );
                        })}
                </div>
            </div>
            <div
                className="fixed h-[100%] w-[100%] bg-black opacity-50 top-0 left-0 cursor-pointer z-[90]"
                onClick={closeModal}
            />
        </Portal>
    );
}
